import React from 'react'
import Config from '../Config'

const ConfigContext = React.createContext()

export function ConfigProvider({ config, ...props }) {
    const defaultConfig = new Config()
    return <ConfigContext.Provider value={config || defaultConfig} {...props} />
}

export function useConfig() {
    const context = React.useContext(ConfigContext)

    if (context === undefined) {
        throw new Error('useConfig must be used with ConfigProvider')
    }

    return context
}
